import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import { FormChange } from "@saleor/hooks/useForm";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { VoucherTypeEnum } from "../../../types/globalTypes";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherFreeShippingValueProps {
  data: VoucherDetailsPageFormData;
  disabled: boolean;
  onChange: FormChange;
}

const VoucherFreeShippingValue: React.FC<VoucherFreeShippingValueProps> = props => {
  const { data, disabled, onChange } = props;

  useEffect(() => {
    if (data.isSpecificCustomer) {
      onChange({ target: { name: "isHidden", value: false } });
    }
  }, [data.isSpecificCustomer]);

  useEffect(() => {
    if (data.verticalType === "SM_FULFILLED") {
      onChange({
        target: { name: "type", value: VoucherTypeEnum.ENTIRE_ORDER }
      });
    }
  }, [data.verticalType]);

  return (
    <Card>
      <CardContent>
        <>
          <ControlledCheckbox
            id="hiddenCheckbox"
            name={"isHidden" as keyof VoucherDetailsPageFormData}
            label={
              <>
                <FormattedMessage
                  defaultMessage="Hidden"
                  description="voucher hide, check box"
                />
              </>
            }
            checked={data.isHidden}
            onChange={onChange}
            disabled={disabled}
          />
        </>
      </CardContent>
    </Card>
  );
};
export default VoucherFreeShippingValue;
